import React from 'react';
import { IconBracelet, IconDiamond, IconEarring, IconLadiesWatch, IconMensWatch, IconNecklace, IconPocketWatch,
IconSterlingSilver, IconGeneric, IconWatchStrap, IconRing} from '../components/products/IconsProductPreloader';

export const GetIcon = (type) =>
{
    let Icon = <IconGeneric />;
    switch (type.toLowerCase()) {
        case "gia diamond":
        case "diamond":
            Icon = <IconDiamond />
            break;
        case "bracelet":
            Icon = <IconBracelet />
            break;
        case "earring":
            Icon = <IconEarring />
            break;
        case "ring":
            Icon = <IconRing />
            break;
        case "ladies watch":
        case "ladies-watch":
            Icon = <IconLadiesWatch />
            break;
        case "watch":
        case "mens watch":
        case "mens-watch":
            Icon = <IconMensWatch />
            break;
        case "necklace":
            Icon = <IconNecklace />
            break;
        case "pocket watch":
            Icon = <IconPocketWatch />
            break;
        case "sterling silver":
        case "sterling-silver":
        case "silver":
            Icon = <IconSterlingSilver />
            break;
        case "watch band":
        case "watch-band":
        case "band":
        case "watch strap":
        case "watch-strap":
        case "strap":
            Icon = <IconWatchStrap />
            break;
    }
    return Icon
}

const IconLoaders = ({ type = 'bracelet' }) => {
    return (
        <div className="line-border">{GetIcon(type)}</div>
    );
}

export default IconLoaders;
